module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"total_reviews_count":"{0}개"}}')
  delete Component.options._Ctor
}
